<template>
    <div v-loading="$parentInfo.Dialogs_ReturnConfirm.loading" class="printOrder-data" >
        <vue-scroll :ops="$ops">
            <div class="noprint" v-show="$parentInfo.Dialogs_ReturnConfirm.printOn">
                <el-button icon="el-icon-printer" v-print="'#print'"
                           size="small">打印合同
                </el-button>
            </div>
            <div :style="{'height':$parentInfo.Dialogs_ReturnConfirm.maxHeight-45+'px'}" id="print">
                <div id="printArea"
                     class="printableArea"
                     v-if="$parentInfo.Dialogs_ReturnConfirm.showOn"
                     :class="{'ph':!$parentInfo.Dialogs_ReturnConfirm.printOn,'show':$parentInfo.Dialogs_ReturnConfirm.printOn}"
                     style=";position: relative;">

                    <div style="position: relative" class="invoice-body">
                        <div>
                            <div>
                                <h3 class="title">教学设备租赁归还确认书</h3>
                            </div>
                            <div>
                                <p>出借人：上海墨帝教育科技服务有限公司</p>
                            </div>
                            <div>
                                <p>
                                    租赁人：<span style="text-decoration: underline">　　{{returnRecord.student_name}}　</span><br>
                                    租赁人监护人：<span style="text-decoration: underline">   {{returnRecord.guardian_name}}  </span><br>
                                    租赁人/租赁人监护人身份证号：<span style="text-decoration: underline">　　 {{returnRecord.guardian_id}}　</span><br>
                                    联系方式：<span style="text-decoration: underline">　　 {{returnRecord.guardian_phone}}　</span>
                                </p>
                            </div>
                            <br>
                            <div>
                                <p>租赁产品：</p>
                                <div class="table-responsive" style="clear: both;">
                                    <table class="table table-bordered">
                                        <thead>
                                        <tr>
                                            <th>名称</th>
                                            <th>序列号</th>
                                            <th>数量</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(item,index) in returnRecord.shopRecords" :key="index">
                                            <td>{{item.shop_name}}</td>
                                            <td>{{item.serial_id}}</td>
                                            <td>{{item.number}}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <p>归还日期：<span style="text-decoration: underline">　{{returnRecord.returnYear}}　</span>年<span style="text-decoration: underline">　{{returnRecord.returnMonth}}　</span>月<span style="text-decoration: underline">　{{returnRecord.returnDay}}　</span>日</p>
                            </div>

                            <div class="table-responsive" style="clear: both;">
                                <table class="table table-bordered" style="width: 400px">
                                    <tbody>
                                    <tr >
                                        <td >初始押金：</td>
                                        <td style="width: 200px">{{returnRecord.balance|currency('￥')}}</td>
                                    </tr>
                                    <tr>
                                        <td>租金合计：</td>
                                        <td>{{returnRecord.total_rent|currency('￥')}}</td>
                                    </tr>
                                    <tr>
                                        <td>维修赔偿款：</td>
                                        <td>{{returnRecord.repair_money|currency('￥')}}</td>
                                    </tr>
                                    <tr>
                                        <td>维修内容：</td>
                                        <td>{{returnRecord.repair_content}}</td>
                                    </tr>

                                    </tbody>
                                </table>
                            </div>
                            <div>
                                <p>剩余押金<span style="text-decoration: underline">　{{returnRecord.remain_balance|currency('￥')}}　</span></p>
                                <p>□支付《墨帝教育服务协议书》相关费用</p>
                                <p>或</p>
                                <p>□退回账户：</p>
                                <p>开户行：<span style="text-decoration: underline">　{{returnRecord.bank_account}}　</span></p>
                                <p>银行账号：<span style="text-decoration: underline">　{{returnRecord.bank_account}}　</span></p>
                                <p>开户人：<span style="text-decoration: underline">　{{returnRecord.account_name}}　</span></p>
                            </div>
                            <br>
                            <div>
                                <p>本回执单仅用于确认租赁人与本公司签订的编号为<span style="text-decoration: underline">　{{returnRecord.prefix}}　</span>的 《教学设备租赁合同》中所述的设备已归还，其他事项以《教学设备租赁合同》及《墨帝教育服务协议书》中约定为准。</p>
                            </div>
                            <br>
                            <div style="float: left;width: 60%">
                                <p>甲方：上海墨帝教育科技服务有限公司</p>
                                <p>_______年______月______日</p>
                            </div>
                            <div style="float: left;">
                                <p>租赁人/租赁人监护人（签字）：__________________</p>
                                <p>_______年______月______日</p>
                            </div>
                            <div style="clear: both"></div>
                        </div>
                    </div>

                </div>
            </div>
        </vue-scroll>

    </div>
</template>
<style lang="scss">
    #msg{
        width:100px !important;
        height:100px !important;
    }
    .show {
        overflow: auto;
    }

    .ph {
        height: 100% !important;
    }

    .printableArea {
        padding: 10px 20px;
        color: #000 !important;
        font-weight: 500;
    }

    .printableArea .invoiceNumber{
        position:absolute;right:30px;font-size:10px;color:rgba(120, 130, 140, 0.74);
    }
    .printableArea .title{
        margin-top: 0;line-height: 30px;font-size: 18px;font-weight: 500;text-align: center;
    }
    .printableArea .main_title{
        margin-top: 0;line-height: 30px;font-weight: 500;text-align: center;
    }
    .printableArea h3 {
        line-height: 30px;
        font-size: 15px;
        font-weight: 500;
    }

    .printableArea p {
        font-size: 12px;
        padding-left: 15px;
        padding-right: 15px;
    }

    .printableArea table {
        font-size: 12px;
        border-color: #000;
    }

    .printableArea .table-bordered > tbody > tr > td, .printableArea .table-bordered > tbody > tr > th,
    .printableArea .table-bordered > tfoot > tr > td, .printableArea .table-bordered > tfoot > tr > th,
    .printableArea .table-bordered > thead > tr > td, .printableArea .table-bordered > thead > tr > th {
        border: 1px solid #000 !important;
        color: #000;
        font-size: 12px;
        font-weight: 500 !important;
    }

    .printableArea .table > tbody > tr > td, .printableArea .table > tbody > tr > th, .printableArea .table > tfoot > tr > td, .printableArea .table > tfoot > tr > th, .printableArea .table > thead > tr > td, .printableArea .table > thead > tr > th {
        padding: 7px 9px;
    }

    .printableArea .table-responsive {
        padding: 0 15px;
    }

    .printableArea .page-break{
        page-break-before: always  !important;
    }

    @media print{
        #print {
            .printableArea {
                padding: 0 !important;
                color: #000 !important;
                font-weight: 500;

            }

            .invoice-body{
                page-break-before:always;
            }

            .printableArea .title{
                margin-top: 0;
                line-height: 40px;
                font-size: 25px;
                font-weight: 500;
                text-align: center;

            }
            .printableArea .invoiceNumber{
                position:absolute;right:30px;font-size:15px;color:rgba(120, 130, 140, 0.74);
            }

            .printableArea h3 {
                line-height: 30px;
                font-size: 21px;
                font-weight: 500;
            }


            .printableArea p {
                font-size: 18px;
                padding-left: 15px;
                padding-right: 15px;
            }

            .printableArea table {
                font-size: 18px;
                border-color: #000;
            }

            .printableArea .table-bordered > tbody > tr > td, .printableArea .table-bordered > tbody > tr > th,
            .printableArea .table-bordered > tfoot > tr > td, .printableArea .table-bordered > tfoot > tr > th,
            .printableArea .table-bordered > thead > tr > td, .printableArea .table-bordered > thead > tr > th {
                border: 1px solid #000 !important;
                color: #000;
                font-size: 18px;
                font-weight: 500 !important;
            }

            .printableArea .table > tbody > tr > td, .printableArea .table > tbody > tr > th, .printableArea .table > tfoot > tr > td, .printableArea .table > tfoot > tr > th, .printableArea .table > thead > tr > td, .printableArea .table > thead > tr > th {
                padding: 7px 9px;
            }

            .printableArea .table-responsive {
                padding: 0 15px;
            }

            .printableArea .page-break{
                page-break-before: always  !important;
            }
        }
    }
</style>
<script>
    import store from '@/store'
    export default {
        name: 'Dialogs_ReturnConfirm',
        data() {
            return {
                invoiceItems:[],
                receiveRecord:[],
                returnRecord:'',
                id:1,
            };
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handlePrintSignature()
        },
        props:{
            invoice_id:'',
        },
        methods: {
            handlePrintSignature(){
                this.$axios.post(store.state.server + '/printReturn',{
                    'invoiceId':this.invoice_id,
                    'balanceType':this.$parentInfo.Dialogs_ReturnEquipment.filter.balanceType,
                    'discountRent':this.$parentInfo.Dialogs_ReturnEquipment.filter.discount_rent,
                    'repairMoney':this.$parentInfo.Dialogs_ReturnEquipment.filter.repair_balance,
                    'repairContent':this.$parentInfo.Dialogs_ReturnEquipment.filter.repair_content,
                    'guardianName':this.$parentInfo.Dialogs_ReturnEquipment.filter.guardianName,
                    'guardianId':this.$parentInfo.Dialogs_ReturnEquipment.filter.guardianId,
                    'guardianPhone':this.$parentInfo.Dialogs_ReturnEquipment.filter.guardianPhone,
                    'remainBalance':this.$parentInfo.Dialogs_ReturnEquipment.filter.remainBalance,
                    'accountName':this.$parentInfo.Dialogs_ReturnEquipment.filter.accountName,
                    'bankAccount':this.$parentInfo.Dialogs_ReturnEquipment.filter.bankAccount,
                    'bank':this.$parentInfo.Dialogs_ReturnEquipment.filter.bank,
                    'totalRent':this.$parentInfo.Dialogs_ReturnEquipment.filter.totalRent,
                    'balance':this.$parentInfo.Dialogs_ReturnEquipment.filter.balance,
                }).then((response) => {
                    if (response.data.code == '0000') {
                        this.returnRecord=response.data.content.returnRecord;
                    }
                }).catch((res) => {
                    this.$parentInfo.Dialogs_ReturnEquipment.dialogVisible=false
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
            modelClose() {
                ipc.send('invoiceDetailClose');
            },

        }
    };
</script>
